import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend) 
  .use(LanguageDetector)
  .use (initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detectBrowserLanguage: {
      useCookie: true,
      cookieKey: 'i18n_redirected',
      redirectOn: 'root'
    },
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json'
    }
  })

window.onload = function() {
  document.querySelector("html").setAttribute('lang', i18n?.language)
}

export default i18n;